import { Option } from "api/types/_public";

export enum ENUM_SCHEDULE {
  ONE_TIME = '1',
  EVERY_DAY = '2',
  EVERY_WEEK = '3',
  EVERY_MONTH = '4',
  INTERVAL = '5',
  CRON_EXPRESSION = '99',
}

export const SCHEDULE_OPTIONS: Option[] = [
  // {
  //   label: "Now",
  //   value: "now",
  // },
  {
    label: "Daily",
    value: ENUM_SCHEDULE.EVERY_DAY,
  },
  {
    label: "Weekly",
    value: ENUM_SCHEDULE.EVERY_WEEK,
  },
  // {
  //   label: "Monthly",
  //   value: "monthly",
  // },
];

export enum VOTE_TYPE {
  COMPLETED = '1',
  ONGOING = '2',
};

export enum VOTE_CYCLE_TYPE {
  DAILY = '1',
  WEEKLY = '2',
};


export const SCHEDULE_VOTE_OPTIONS: Option[] = [
  {
    label: "Daily",
    value: VOTE_CYCLE_TYPE.DAILY,
  },
  {
    label: "Weekly",
    value: VOTE_CYCLE_TYPE.WEEKLY,
  }
];

export const TYPE_VOTE_OPTIONS: Option[] = [
  {
    label: "Completed Votes",
    value: VOTE_TYPE.COMPLETED,
  },
  {
    label: "Ongoing Votes",
    value: VOTE_TYPE.ONGOING,
  }
];

export const SCHEDULE_MONTHLY_OPTIONS: Option[] = Array.from(
  { length: 31 },
  (_, index) => {
    const day = (index + 1).toString().padStart(2, "0");
    return { label: `${day}th`, value: day };
  }
);

export const ARR_INDEX_TEXT_DAY_OF_WEEK: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const SCHEDULE_WEEKLY_OPTIONS: Option[] = [
  {
    label: "Monday",
    value: "1",
  },
  {
    label: "Tuesday",
    value: "2",
  },
  {
    label: "Wednesday",
    value: "3",
  },
  {
    label: "Thursday",
    value: "4",
  },
  {
    label: "Friday",
    value: "5",
  },
  {
    label: "Saturday",
    value: "6",
  },
  {
    label: "Sunday",
    value: "0",
  },
];

export const TYPE_SHOW_MORE_HASHTAG = {
  SCROLL: 'scroll',
  MODAL: 'modal'
}

export const FILL_RATE_TIME_OPTIONS: Option[] = [
  {
    label: "01",
    value: "1",
  },
  {
    label: "02",
    value: "2",
  },
  {
    label: "03",
    value: "3",
  },
  {
    label: "04",
    value: "4",
  },
  {
    label: "05",
    value: "5",
  },
  {
    label: "06",
    value: "6",
  },
  {
    label: "07",
    value: "7",
  },
  {
    label: "08",
    value: "8",
  },
  {
    label: "09",
    value: "9",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "13",
    value: "13",
  },
  {
    label: "14",
    value: "14",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "16",
    value: "16",
  },
  {
    label: "17",
    value: "17",
  },
  {
    label: "18",
    value: "18",
  },
  {
    label: "19",
    value: "19",
  },
  {
    label: "20",
    value: "20",
  },
  {
    label: "21",
    value: "21",
  },
  {
    label: "22",
    value: "22",
  },
  {
    label: "23",
    value: "23",
  },
  {
    label: "24",
    value: "24",
  },
];


export const OPERATING_OPTIONS: Option[] = [
  {
    label: "00:00",
    value: "0",
  },
  {
    label: "01:00",
    value: "1",
  },
  {
    label: "02:00",
    value: "2",
  },
  {
    label: "03:00",
    value: "3",
  },
  {
    label: "04:00",
    value: "4",
  },
  {
    label: "05:00",
    value: "5",
  },
  {
    label: "06:00",
    value: "6",
  },
  {
    label: "07:00",
    value: "7",
  },
  {
    label: "08:00",
    value: "8",
  },
  {
    label: "09:00",
    value: "9",
  },
  {
    label: "10:00",
    value: "10",
  },
  {
    label: "11:00",
    value: "11",
  },
  {
    label: "12:00",
    value: "12",
  },
  {
    label: "13:00",
    value: "13",
  },
  {
    label: "14:00",
    value: "14",
  },
  {
    label: "15:00",
    value: "15",
  },
  {
    label: "16:00",
    value: "16",
  },
  {
    label: "17:00",
    value: "17",
  },
  {
    label: "18:00",
    value: "18",
  },
  {
    label: "19:00",
    value: "19",
  },
  {
    label: "20:00",
    value: "20",
  },
  {
    label: "21:00",
    value: "21",
  },
  {
    label: "22:00",
    value: "22",
  },
  {
    label: "23:00",
    value: "23",
  },
  {
    label: "24:00",
    value: "24",
  },
];


export const TYPE_ADS_DEVICE_OPTIONS: Option[] = [
  {
    label: "Mobile",
    value: "Mobile",
  },
  {
    label: "PC",
    value: "PC",
  },
];

export const DEVICE_OPTIONS: Option[] = [
  {
    label: "Device_pc",
    value: "pc",
  },
  {
    label: "Device_mobile",
    value: "mobile",
  },
];

export const BROWSER_OPTIONS: Option[] = [
  {
    label: "Browser_Samsung",
    value: 'Samsung Browser',
  },
  {
    label: "Browser_Chrome",
    value: 'Chrome',
  },
  {
    label: "Browser_Safari",
    value: 'Safari',
  },
  {
    label: "Browser_Unknown_Browser",
    value: 'Unknown Browser',
  },
];

export const PLATFORM_LOG_OPTIONS: Option[] = [
  {
    label: "Platform_naver",
    value: "naver",
  },
  {
    label: "Platform_google",
    value: "google",
  },
  {
    label: "Platform_daum",
    value: "daum",
  },
  {
    label: "Platform_etc",
    value: "etc",
  },
];

export const AD_TYPE_INVENTORY_IS_FLOATING_BANNER = '1'; // Floating Banner

export const AD_TYPE_INVENTORY_IS_FIXED_BANNER = '2'; // Fixed Banner

export const AD_TYPE_INVENTORY_IS_FIXED_BANNER_SNS = '3'; // Fixed Banner (SNS)

export const AD_TYPE_INVENTORY_IS_IFRAME = '4'; // Iframe

export const AD_TYPE_INVENTORY_IS_FULL_SCREEN = '5'; // Full-Screen


export const AD_TYPE_INVENTORY_OPTIONS: Option[] = [
  {
    label: "Ad_Type_Inventory_1", // Floating Banner 
    value: AD_TYPE_INVENTORY_IS_FLOATING_BANNER,
  },
  {
    label: "Ad_Type_Inventory_2", // Fixed Banner 
    value: AD_TYPE_INVENTORY_IS_FIXED_BANNER,
  },
  // {
  //   label: "Ad_Type_Inventory_3", // Fixed Banner (SNS)
  //   value: AD_TYPE_INVENTORY_IS_FIXED_BANNER_SNS,
  // },
  // {
  //   label: "Ad_Type_Inventory_4", // Iframe
  //   value: AD_TYPE_INVENTORY_IS_IFRAME,
  // },
  {
    label: "Ad_Type_Inventory_5", // Full-Screen
    value: AD_TYPE_INVENTORY_IS_FULL_SCREEN,
  },
];

export const AD_PLATFORM_LOG_OPTIONS: Option[] = [
  // {
  //   label: "Platform_ad_system",
  //   value: "ad_system",
  // },
  {
    label: "Platform_coupang",
    value: "coupang",
  },
  {
    label: "Platform_dc",
    value: "dc",
  },
];

export const AD_TYPE_OPTIONS: Option[] = [
  {
    label: "Type_close",
    value: "close",
  },
  {
    label: "Type_click",
    value: "click",
  },
  {
    label: "Type_impression",
    value: "impression",
  },
  {
    label: "Type_request",
    value: "request",
  },
  {
    label: "Type_block",
    value: "block",
  },
];

export const CLICK_TYPE_NORMAL = 'normal';
export const CLICK_TYPE_FORCE = 'force_click_layer';
export const CLICK_TYPE_AUTO_POPUP = 'auto_click_popup';
export const CLICK_TYPE_AUTO_REDIRECT = 'auto_redirect';

export const CLICK_TYPE_OPTIONS: Option[] = [
  {
    label: "Normal",
    value: CLICK_TYPE_NORMAL,
  },
  {
    label: "Force Click (Layer)",
    value: CLICK_TYPE_FORCE,
  },
  {
    label: "Automatic Click (Popup)",
    value: CLICK_TYPE_AUTO_POPUP,
  },
  {
    label: "Automatic Redirect",
    value: CLICK_TYPE_AUTO_REDIRECT,
  },
];

export const IS_OPTIONS: Option[] = [
  {
    label: "YES",
    value: "1",
  },
  {
    label: "NO",
    value: "0",
  },
];


export const OS_OPTIONS: Option[] = [
  {
    label: "OS_iOS",
    value: 'iOS',
  },
  {
    label: "OS_Mac",
    value: 'Mac',
  },
  {
    label: "OS_Windows",
    value: 'Windows',
  },
  {
    label: "OS_Android",
    value: 'Android',
  },
  {
    label: "OS_Etc",
    value: 'Etc',
  },
];

export const METHOD_OPTIONS: Option[] = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "POST",
    value: "POST",
  },
  {
    label: "PUT",
    value: "PUT",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
];

export const STATUS_USER_OPTIONS: Option[] = [
  {
    label: "Active", // Active
    value: "1",
  },
  {
    label: "Inactive", // Inactive
    value: "0",
  },
];

export enum NEWS_GENERATE_REQUEST_STATUS {
  PENDING = 10,
  COLLECTING = 20,
  COLLECT_ERROR = 21,
  COLLECTED = 22,
  GENERATING = 30,
  GENERATE_ERROR = 31,
  ERROR_NOT_ENOUGH_NEWS = 32,
  COMPLETED = 100,
  OTHER_ERROR = 999,
}

export const COLORS_STATUS_GENERATE_NEWS: any = {
  [`${NEWS_GENERATE_REQUEST_STATUS.PENDING}`]: 'primary',
  [`${NEWS_GENERATE_REQUEST_STATUS.COLLECTING}`]: 'primary',
  [`${NEWS_GENERATE_REQUEST_STATUS.COLLECT_ERROR}`]: 'danger',
  [`${NEWS_GENERATE_REQUEST_STATUS.COLLECTED}`]: 'success',
  [`${NEWS_GENERATE_REQUEST_STATUS.GENERATING}`]: 'primary',
  [`${NEWS_GENERATE_REQUEST_STATUS.GENERATE_ERROR}`]: 'danger',
  [`${NEWS_GENERATE_REQUEST_STATUS.ERROR_NOT_ENOUGH_NEWS}`]: 'danger',
  [`${NEWS_GENERATE_REQUEST_STATUS.COMPLETED}`]: 'success',
  [`${NEWS_GENERATE_REQUEST_STATUS.OTHER_ERROR}`]: 'danger',
};

export const STATUS_GENERATE_NEWS_OPTIONS: Option[] = [
  {
    label: "Pending", // Pending
    value: `${NEWS_GENERATE_REQUEST_STATUS.PENDING}`,
  },
  {
    label: "Collecting", // Collecting
    value: `${NEWS_GENERATE_REQUEST_STATUS.COLLECTING}`,
  },
  {
    label: "Generating", // Generating
    value: `${NEWS_GENERATE_REQUEST_STATUS.GENERATING}`,
  },
  {
    label: "Collected", // Collected
    value: `${NEWS_GENERATE_REQUEST_STATUS.COLLECTED}`,
  },
  {
    label: "Completed", // Completed
    value: `${NEWS_GENERATE_REQUEST_STATUS.COMPLETED}`,
  },
  {
    label: "Collect Error", // Collect Error
    value: `${NEWS_GENERATE_REQUEST_STATUS.COLLECT_ERROR}`,
  },
  {
    label: "Generate Error", // Generate Error
    value: `${NEWS_GENERATE_REQUEST_STATUS.GENERATE_ERROR}`,
  },
  {
    label: "Error Not Enough", // Error Not Enough
    value: `${NEWS_GENERATE_REQUEST_STATUS.ERROR_NOT_ENOUGH_NEWS}`,
  },
  {
    label: "Other Error", // Other Error
    value: `${NEWS_GENERATE_REQUEST_STATUS.OTHER_ERROR}`,
  },
];

export enum NEWS_GENERATE_REQUEST_SOURCE_TYPE {
  NAVER_NEWS = 100,
  NAMUWIKI = 200,
  GENERAL = 300,
  CAR = 400,
}

export const COLORS_STATUS_KEYWORD_BOOST: any = {
  '0': 'secondary',
  '1': 'primary',
};

export const STATUS_KEYWORD_BOOST_OPTIONS: Option[] = [
  {
    label: "Active", // Active
    value: "1",
  },
  {
    label: "Inactive", // Inactive
    value: "0",
  },
];

export const COLORS_STATUS_CAMPAIGN: any = {
  '0': 'danger',
  '1': 'success',
};

export const STATUS_CAMPAIGN_OPTIONS: Option[] = [
  {
    label: "Active", // Active
    value: "1",
  },
  {
    label: "Inactive", // Inactive
    value: "0",
  },
];


export enum KEYWORD_TYPE {
  NEWS = 1,
  CONTENT = 2,
  NEWS_V2 = 3,
  SYSTEM = 99,
}

export const COLORS_KEYWORD_TYPE: any = {
  [`${KEYWORD_TYPE.NEWS}`]: 'success',
  [`${KEYWORD_TYPE.CONTENT}`]: 'primary',
  [`${KEYWORD_TYPE.NEWS_V2}`]: 'warning',
  [`${KEYWORD_TYPE.SYSTEM}`]: 'danger',
};

export const KEYWORD_TYPE_OPTIONS: Option[] = [
  {
    label: "News", // News
    value: `${KEYWORD_TYPE.NEWS}`,
  },
  {
    label: "News v2", // News v2
    value: `${KEYWORD_TYPE.NEWS_V2}`,
  },
  // {
  //   label: "Travel News", // Travel News
  //   value: `${KEYWORD_TYPE.TRAVEL_NEWS}`,
  // },
  {
    label: "Content", // Content
    value: `${KEYWORD_TYPE.CONTENT}`,
  },
  // {
  //   label: "System", // System
  //   value: `${KEYWORD_TYPE.SYSTEM}`,
  // },
];

export enum KEYWORD_PUBLISH_LOG_TYPE {
  YES = 1,
  NO = 2,
}
export const COLORS_KEYWORD_PUBLISH_LOG_TYPE: any = {
  [`${KEYWORD_PUBLISH_LOG_TYPE.YES}`]: 'success',
  [`${KEYWORD_PUBLISH_LOG_TYPE.NO}`]: 'danger',
};

export const KEYWORD_PUBLISH_LOG_TYPE_OPTIONS: Option[] = [
  {
    label: "Ranked", // Ranked
    value: `${KEYWORD_PUBLISH_LOG_TYPE.YES}`,
  },
  {
    label: "Unranked", // Unranked
    value: `${KEYWORD_PUBLISH_LOG_TYPE.NO}`,
  },
];

export enum KEYWORD_NAVER_REGISTER_STATUS {
  REGISTERED = 2,
  NOT_REGISTERED = 1
}

export const COLORS_KEYWORD_NAVER_REGISTER_STATUS: any = {
  [`${KEYWORD_NAVER_REGISTER_STATUS.REGISTERED}`]: 'success',
  [`${KEYWORD_NAVER_REGISTER_STATUS.NOT_REGISTERED}`]: 'danger',
};

export const KEYWORD_NAVER_REGISTER_STATUS_OPTIONS: Option[] = [
  {
    label: "No Registered", // No Registered
    value: `${KEYWORD_NAVER_REGISTER_STATUS.NOT_REGISTERED}`,
  },
  {
    label: "Registered", // Registered
    value: `${KEYWORD_NAVER_REGISTER_STATUS.REGISTERED}`,
  },
];

export enum AIModel {
  GEMMA2_9B = 'gemma2:9b',
  GEMMA2_27B = 'gemma2:27b',
  GEMMA3_27B = 'gemma3:27b',
  GEMMA3_12B = 'gemma3:12b',
  CHATGPT_4o = 'gpt-4o',
  GEMINI_2_0_FLASH = 'gemini-2.0-flash',
  GEMINI_2_5_FLASH = 'gemini-2.5-flash',
}

export const COLORS_AI_MODEL: any = {
  [AIModel.GEMMA2_9B]: 'success',
  [AIModel.GEMMA2_27B]: 'primary',
  [AIModel.GEMMA3_27B]: 'warning',
  [AIModel.GEMMA3_12B]: 'info',
  [AIModel.CHATGPT_4o]: 'danger',
  [AIModel.GEMINI_2_5_FLASH]: 'success',
};


export const AI_MODEL_OPTIONS: Option[] = [
  // {
  //   label: "GEMMA2 9B", // GEMMA2_9B
  //   value: AIModel.GEMMA2_9B,
  // },
  // {
  //   label: "GEMMA2 27B", // GEMMA2_27B
  //   value: AIModel.GEMMA2_27B,
  // },
  {
    label: "GEMMA3 27B", // GEMMA3_27B
    value: AIModel.GEMMA3_27B,
  },
  {
    label: "GEMMA3 12B", // GEMMA3_12B
    value: AIModel.GEMMA3_12B,
  },
  {
    label: "CHATGPT 4o", // CHATGPT_4o
    value: AIModel.CHATGPT_4o,
  },
];

export const AI_MODEL_BOOSTING_NEWS_V2_OPTIONS: Option[] = [
  {
    label: "GEMMA3 27B", // GEMMA3_27B
    value: AIModel.GEMMA3_27B,
  },
  {
    label: "GEMINI 2.5 FLASH", // GEMINI_2_5_FLASH
    value: AIModel.GEMINI_2_5_FLASH,
  },
];

export const AI_MODEL_BOOSTING_NEWS_TRAVEL_OPTIONS: Option[] = [
  {
    label: "GEMMA3 27B", // GEMMA3_27B
    value: AIModel.GEMMA3_27B,
  },
  {
    label: "GEMINI 2.5 FLASH", // GEMINI_2_5_FLASH
    value: AIModel.GEMINI_2_5_FLASH,
  },
];

export const AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS: Option[] = [
  {
    label: "GEMINI 2.5 FLASH", // GEMINI_2_5_FLASH
    value: AIModel.GEMINI_2_5_FLASH,
  },
];

export const AI_MODEL_APP_TECH_OPTIONS: Option[] = [
  {
    label: "GEMMA3 27B", // GEMMA3_27B
    value: AIModel.GEMMA3_27B,
  },
  {
    label: "GEMMA3 12B", // GEMMA3_12B
    value: AIModel.GEMMA3_12B,
  },
];

export const AI_MODEL_NEWS_STOCK_OPTIONS: Option[] = [
  {
    label: "GEMMA3 27B", // GEMMA3_27B
    value: AIModel.GEMMA3_27B,
  },
  {
    label: "GEMINI 2.5 FLASH", // GEMINI_2_5_FLASH
    value: AIModel.GEMINI_2_5_FLASH,
  },
];

export const AI_MODEL_NEWS_TOSS_STOCK_OPTIONS: Option[] = [
  {
    label: "GEMMA3 27B", // GEMMA3_27B
    value: AIModel.GEMMA3_27B,
  },
  {
    label: "GEMINI 2.5 FLASH", // GEMINI_2_5_FLASH
    value: AIModel.GEMINI_2_5_FLASH,
  },
];

export enum MAIL_STATUS {
  PENDING = 0,
  ERROR = 99,
  SUCCESS = 100,
}

export const COLORS_STATUS_SEND_MAIL: any = {
  [`${MAIL_STATUS.PENDING}`]: 'primary',
  [`${MAIL_STATUS.ERROR}`]: 'danger',
  [`${MAIL_STATUS.SUCCESS}`]: 'success',
};

export const STATUS_SEND_MAIL_OPTIONS: Option[] = [
  {
    label: "Success", // SUCCESS
    value: `${MAIL_STATUS.SUCCESS}`,
  },
  {
    label: "Error", // ERROR
    value: `${MAIL_STATUS.ERROR}`,
  },
  {
    label: "Pending", // PENDING
    value: `${MAIL_STATUS.PENDING}`,
  },
];


export enum MAIL_STATUS_READ {
  READ = 1,
  UN_READ = 0,
}

export const COLORS_STATUS_READ_MAIL: any = {
  [`${MAIL_STATUS_READ.READ}`]: 'success',
  [`${MAIL_STATUS_READ.UN_READ}`]: 'danger',
};

export const STATUS_READ_MAIL_OPTIONS: Option[] = [
  {
    label: "Read", // READ
    value: `${MAIL_STATUS_READ.READ}`,
  },
  {
    label: "Unread", // UN_READ
    value: `${MAIL_STATUS_READ.UN_READ}`,
  },
];


export const COLORS_STATUS_OUT_LINK: any = {
  '0': 'secondary',
  '1': 'success',
  '2': 'primary',
};

export const STATUS_OUT_LINK_OPTIONS: Option[] = [
  {
    label: "OUT_LINK", // OUT_LINK
    value: "1",
  },
  {
    label: "CP", // CP
    value: "2",
  },
];

export const COLORS_SECTION_KEYWORD: any = {
  '100': 'success',
  '200': 'danger',
  '201': 'primary',
  '202': 'warning',
  '203': 'green',
  '204': 'secondary',
  '205': 'purple',
  '206': 'pink',
  '207': 'info',
  '300': 'dark'
};

export enum SECTION_KEYWORD {
  GOOGLE_TREND = 100,
  NAVER_POLITICS = 200,
  NAVER_ECONOMY = 201,
  NAVER_SOCIETY = 202,
  NAVER_LIFE_CULTURE = 203,
  NAVER_IT_SCIENCE = 204,
  NAVER_WORLD = 205,
  NAVER_ENTERTAIN = 206,
  NAVER_SPORT = 207,
  BOOSTING = 300,
  BOOSTING_V2 = 301,
  TRAVEL_NEWS = 302,
  STOCK_NEWS = 303,
  TOSS_STOCK_NEWS = 304,
  WEATHER_NEWS = 305,
  WEATHER_WARNING = 306,
  REAL_TIME = 400,
  EXTERNAL = 500,
  CONTENT_CAR = 600,
  CONTENT_APPTECH = 700,
  CONTENT_GOLD_PRICE = 800,
  CONTENT_VOTE = 900,
  CONTENT_VOTE_KEYWORD = 1000,
  GOVERNMENT_IMAGE_BASED_NEWS = 1100,
  GOVERNMENT_LOGO_BASED_NEWS = 1101,
}

export const KEY_GET_SOURCE: any = {
  [`${SECTION_KEYWORD.CONTENT_APPTECH}`]: 'source_app_tech',
  [`${SECTION_KEYWORD.CONTENT_GOLD_PRICE}`]: 'source_gold_price',
  [`${SECTION_KEYWORD.CONTENT_VOTE}`]: 'source_voting',
  [`${SECTION_KEYWORD.CONTENT_VOTE_KEYWORD}`]: 'source_vote_keyword',
  [`${SECTION_KEYWORD.BOOSTING_V2}`]: 'source_news_v2',
  [`${SECTION_KEYWORD.TRAVEL_NEWS}`]: 'source_travel_place.places',
  [`${SECTION_KEYWORD.WEATHER_NEWS}`]: 'source_weather',
  [`${SECTION_KEYWORD.WEATHER_WARNING}`]: 'source_weather_warning',
  [`${SECTION_KEYWORD.STOCK_NEWS}`]: 'source_stock',
  [`${SECTION_KEYWORD.TOSS_STOCK_NEWS}`]: 'source_stock',
};

export const SECTION_KEYWORD_OPTIONS: Option[] = [
  {
    label: `Google`,
    value: String(SECTION_KEYWORD.GOOGLE_TREND),
  },
  {
    label: `Politics`,
    value: String(SECTION_KEYWORD.NAVER_POLITICS),
  },
  {
    label: `Economy`,
    value: String(SECTION_KEYWORD.NAVER_ECONOMY),
  },
  {
    label: `Society`,
    value: String(SECTION_KEYWORD.NAVER_SOCIETY),
  },
  {
    label: `Life/Culture`,
    value: String(SECTION_KEYWORD.NAVER_LIFE_CULTURE),
  },
  {
    label: `IT/Science`,
    value: String(SECTION_KEYWORD.NAVER_IT_SCIENCE),
  },
  {
    label: `World`,
    value: String(SECTION_KEYWORD.NAVER_WORLD),
  },
  {
    label: `Entertainment`,
    value: String(SECTION_KEYWORD.NAVER_ENTERTAIN),
  },
  {
    label: `Sports`,
    value: String(SECTION_KEYWORD.NAVER_SPORT),
  },
  // {
  //   label: `Boosting`,
  //   value: String(SECTION_KEYWORD.BOOSTING),
  // },
];

export const SECTION_TYPE_CONTENT_OPTIONS: Option[] = [
  {
    label: `Car`,
    value: String(SECTION_KEYWORD.CONTENT_CAR),
  },
  {
    label: `AppTech`,
    value: String(SECTION_KEYWORD.CONTENT_APPTECH),
  },
  {
    label: `Gold Prices`,
    value: String(SECTION_KEYWORD.CONTENT_GOLD_PRICE),
  },
  {
    label: `Vote`,
    value: String(SECTION_KEYWORD.CONTENT_VOTE),
  },
  {
    label: `Vote Keyword`,
    value: String(SECTION_KEYWORD.CONTENT_VOTE_KEYWORD),
  },
  {
    label: `Travel`,
    value: String(SECTION_KEYWORD.TRAVEL_NEWS),
  },
  {
    label: `Weather`,
    value: String(SECTION_KEYWORD.WEATHER_NEWS),
  },
  {
    label: `Weather Warning`,
    value: String(SECTION_KEYWORD.WEATHER_WARNING),
  },
  {
    label: `Stock`,
    value: String(SECTION_KEYWORD.STOCK_NEWS),
  },
  {
    label: `Toss Stock`,
    value: String(SECTION_KEYWORD.TOSS_STOCK_NEWS),
  },
];


export enum GOVERNMENT_SOURCE_NEWS_TYPE {
  IMAGE_BASED_NEWS = 1,
  LOGO_BASED_NEWS = 2,
}

export enum PUBLISH_NEWS_TYPE {
  AI_NEWS = 1,
  BOOSTING_NEWS = 2,
}

export const COLORS_SECTION_TYPE_CONTENT: any = {
  [`${SECTION_KEYWORD.CONTENT_CAR}`]: 'success',
  [`${SECTION_KEYWORD.CONTENT_APPTECH}`]: 'danger',
  [`${SECTION_KEYWORD.CONTENT_GOLD_PRICE}`]: 'warning',
};


export enum ENUM_STATUS_NEWS {
  USED = 1,
  UNUSED = 0,
};

export const COLORS_STATUS_NEWS: any = {
  '0': 'success',
  '1': 'danger',
};

export const STATUS_NEWS_OPTIONS: Option[] = [
  {
    label: 'Unused', // Unused
    value: `${ENUM_STATUS_NEWS.UNUSED}`,
  },
  {
    label: 'Used', // Used
    value: `${ENUM_STATUS_NEWS.USED}`,
  },
];


export enum ENUM_SENTIMENT_NEWS {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
  NEUTRAL = 'Neutral',
};

export const COLORS_SENTIMENT_NEWS: any = {
  [`${ENUM_SENTIMENT_NEWS.POSITIVE}`]: 'primary',
  [`${ENUM_SENTIMENT_NEWS.NEGATIVE}`]: 'danger',
  [`${ENUM_SENTIMENT_NEWS.NEUTRAL}`]: 'secondary',
};

export const SENTIMENT_NEWS_OPTIONS: Option[] = [
  {
    label: 'Positive', // Positive
    value: `${ENUM_SENTIMENT_NEWS.POSITIVE}`,
  },
  {
    label: 'Negative', // Negative
    value: `${ENUM_SENTIMENT_NEWS.NEGATIVE}`,
  },
  {
    label: 'Neutral', // Neutral
    value: `${ENUM_SENTIMENT_NEWS.NEUTRAL}`,
  },
];

export const COLOR_TYPE_SENTIMENT: any = {
  'Positive': 'primary',
  'Negative': 'danger',
  'Neutral': 'muted'
}

export enum NEWS_TYPE {
  AI_NEWS = 1,
  BOOSTING_NEWS = 2,
  REALTIME_NEWS = 3,
  EXTERNAL_NEWS = 4,
  CONTENT_CAR = 5,
}

export const TYPE_NEWS_OPTIONS: Option[] = [
  {
    label: 'AI News', // AI News
    value: `${NEWS_TYPE.AI_NEWS}`,
  },
  {
    label: 'Boosting News', // Boosting News
    value: `${NEWS_TYPE.BOOSTING_NEWS}`,
  },
  {
    label: 'Real-Time News', // Real-Time News
    value: `${NEWS_TYPE.REALTIME_NEWS}`,
  },
  // {
  //   label: 'External News', // External News
  //   value: `${NEWS_TYPE.EXTERNAL_NEWS}`,
  // },
];


export enum TYPE_LEVEL_KEYWORD {
  GOLDEN = 1,
  GENERAL = 0,
}

export const TYPE_LEVEL_KEYWORD_OPTIONS: Option[] = [
  {
    label: 'Golden Keyword', // Golden Keyword
    value: `${TYPE_LEVEL_KEYWORD.GOLDEN}`,
  },
  {
    label: 'General Keyword', // General Keyword
    value: `${TYPE_LEVEL_KEYWORD.GENERAL}`,
  },
];


export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'];

export enum ENUM_RANK_NEWS {
  TOP_1_TO_5 = 'top_1_to_5',
  TOP_6_TO_ALL = 'top_6_to_all',
};

export const COLORS_RANK_NEWS: any = {
  [`${ENUM_RANK_NEWS.TOP_1_TO_5}`]: 'primary',
  [`${ENUM_RANK_NEWS.TOP_6_TO_ALL}`]: 'danger',
};

export const RANK_NEWS_OPTIONS: Option[] = [
  {
    label: 'Top 1–5', // Top 1–5
    value: `${ENUM_RANK_NEWS.TOP_1_TO_5}`,
  },
  {
    label: 'Rank 6 and above', // Rank 6 and above
    value: `${ENUM_RANK_NEWS.TOP_6_TO_ALL}`,
  },
];



export enum ENUM_NEWS_CREATE_TASK_GROUP {
  DIRECT = 1,
  GROUP_1 = 10,
  GROUP_2 = 20,
  NONE = 99
}

export const NEWS_CREATE_TASK_GROUP_OPTIONS: Option[] = [
  {
    label: 'Group 1', // Group 1
    value: `${ENUM_NEWS_CREATE_TASK_GROUP.GROUP_1}`,
  },
  {
    label: 'Group 2', // Group 2
    value: `${ENUM_NEWS_CREATE_TASK_GROUP.GROUP_2}`,
  },
  {
    label: 'Direct', // Direct
    value: `${ENUM_NEWS_CREATE_TASK_GROUP.DIRECT}`,
  },
];

export const NEWS_CREATE_TASK_GROUP_FILTER_OPTIONS: Option[] = [
  {
    label: 'Group 1', // Group 1
    value: `${ENUM_NEWS_CREATE_TASK_GROUP.GROUP_1}`,
  },
  {
    label: 'Group 2', // Group 2
    value: `${ENUM_NEWS_CREATE_TASK_GROUP.GROUP_2}`,
  },
  {
    label: 'Direct', // Direct
    value: `${ENUM_NEWS_CREATE_TASK_GROUP.DIRECT}`,
  },
  {
    label: 'None', // None
    value: `${ENUM_NEWS_CREATE_TASK_GROUP.NONE}`,
  },
];



export const COLORS_GENNERATE_NEWS: any = {
  [`1`]: 'success',
  [`0`]: 'danger',
};

export const STATUS_GENERATE_NEWS_OF_KEYWORD_OPTIONS: Option[] = [
  {
    label: 'Generated', // Generated
    value: `1`,
  },
  {
    label: 'Not Generated', // Not Generated
    value: `0`,
  },
];


export const STATUS_ARTICLE_OPTIONS: Option[] = [
  {
    label: 'Article Completed', // Completed
    value: `1`,
  },
  {
    label: 'Article Incomplete', // Incomplete
    value: `0`,
  },
];

export enum APP_TECH_TYPE {
  AUTOMATIC = '1',
  MANUAL = '2',
}

export const APP_TECH_TYPE_OPTIONS: Option[] = [
  {
    label: 'Manual', // Manual
    value: APP_TECH_TYPE.MANUAL,
  },
  {
    label: 'Automatic', // Automatic
    value: APP_TECH_TYPE.AUTOMATIC,
  },
];

export const FREQUENCY_TYPE: any = {
  DAILY: 1,
  WEEKLY: 2,
  MONTHLY: 3,
};

export enum CAMPAIGN_TYPE {
  CAR = 1,
  APPTECH = 2,
  GOLD_PRICE = 3,
  VOTE = 4,

}

export enum UPLOAD_ACTION {
  DEFAULT = 0,
  MAILER_CONTENT = 10,
  MAILER_ATTACHMENT = 11,
  NEWS_CONTENT = 12,
  APPTECH = 20,
  GOLD_PRICE = 30,
  VOTE_KEYWORD = 40,
}

export enum VOTE_KEYWORD_IMAGE_TYPE {
  DC_TREND = 1,
  PRESS_AI = 2,
}

export enum APP_TECH_TEMPLATE_TYPE {
  TITLE = 1,
  IMAGE = 2,
  LEAD_PARAGRAPH = 3,
  CLOSING_PARAGRAPH = 4,
}

export enum TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT {
  COMMON = 1,
  GOLD_PRICE = 100,
  CAR = 200,
  VOTE = 300,
  COMPLETED_VOTE_KEYWORD = 400,
  ONGOING_VOTE_KEYWORD = 500,
}

export enum TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT {
  TITLE = 1,
  BODY = 2,
}

export enum BLOG_ANSWER_STATUS {
  INITIAL = '0',
  COLLECTED = '1',
  CONTENT_GENERATED = '2',
}

export const CATEGORY_TEMPLATE_VOTE_KEYWORD_OPTIONS = [
  {
    label: 'Ongoing Vote',
    value: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.ONGOING_VOTE_KEYWORD
  },
  {
    label: 'Ended Vote',
    value: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.COMPLETED_VOTE_KEYWORD
  }
];

export const BLOG_ANSWER_STATUS_OPTIONS: Option[] = [
  {
    label: 'Initial',
    value: BLOG_ANSWER_STATUS.INITIAL
  },
  {
    label: 'Collected',
    value: BLOG_ANSWER_STATUS.COLLECTED
  },
  {
    label: 'Generated',
    value: BLOG_ANSWER_STATUS.CONTENT_GENERATED
  }
];

export enum EXCEL_UPLOAD_TYPE {
  MEDIA_FILE = '1',
  IMAGE = '2',
  STOCK_NEWS = '3',
}

export enum EXCEL_UPLOAD_STATUS {
  INIT = '1',
  SUCCESS = '2',
  CANCELLED = '3',
}

export const EXCEL_UPLOAD_TYPE_OPTIONS: Option[] = [
  {
    label: 'Media File',
    value: EXCEL_UPLOAD_TYPE.MEDIA_FILE,
  },
  {
    label: 'Image',
    value: EXCEL_UPLOAD_TYPE.IMAGE,
  },
  {
    label: 'Stock News',
    value: EXCEL_UPLOAD_TYPE.STOCK_NEWS,
  },
];
export const EXCEL_UPLOAD_STATUS_OPTIONS: Option[] = [
  {
    label: 'Initial',
    value: EXCEL_UPLOAD_STATUS.INIT,
  },
  {
    label: 'Success',
    value: EXCEL_UPLOAD_STATUS.SUCCESS,
  },
  {
    label: 'Cancelled', // Cancelled
    value: EXCEL_UPLOAD_STATUS.CANCELLED,
  },
];


export enum NEWS_STOCK_LOG_TYPE {
  STOCK = '1',
  STOCK_TOSS = '2',
}

export enum SYSTEM_CONFIG_KEY {
  NEWS_AI_CREATE_PROMPT_FORMAT = 'news_ai:create:prompt_format',
  NEWS_AI_CREATE_TOTAL_NEWS_PER_DAY = 'news_ai:create:total_news_per_day',
  NEWS_AI_CREATE_TITLE_COUNT = 'news_ai:create:keyword:title_count',
  NEWS_AI_CREATE_BODY_COUNT = 'news_ai:create:keyword:body_count',
  NEWS_AI_CREATE_CONTENT_COUNT = 'news_ai:create:keyword:content_count',
  NEWS_AI_CREATE_CONTENT_COUNT_SUB_KEYWORD = 'news_ai:create:sub_keyword:content_count',
  NEWS_AI_CREATE_SOURCE_COUNT = 'news_ai:create:source_count',
  NEWS_AI_CREATE_SOURCE_START_MINUS_DAY = 'news_ai:create:source_start_minus_day',
  NEWS_AI_CREATE_SOURCE_MAX = 'news_ai:create:source_max',
  NEWS_AI_CREATE_ALLOW_REUSE_SOURCE_ARTICLE = 'news_ai:create:allow_reuse_source_article',
  NEWS_AI_CREATE_ALLOW_NEWS_GENERATION = 'news_ai:create:flag',
  NEWS_AI_CREATE_KEYWORD_EXCLUDE = 'news_ai:create:keyword_exclude',
  NEWS_AI_CREATE_KEYWORD_EXCLUDE_BODY = 'news_ai:create:keyword_exclude_body',

  AI_NEWS_GENERATION_PROMPT = 'ai_news_generation:prompt',
  AI_NEWS_GENERATION_MODEL = 'ai_news_generation:model',
  AI_NEWS_GENERATION_ADD_NEXT = 'ai_news_generation:add_next',

  USER_POPULAR_CATEGORY_IDS = 'user:popular:category_ids',

  NEWS_BOOSTING_CREATE_PROMPT_FORMAT = 'news_boosting:create:prompt_format',
  NEWS_BOOSTING_CREATE_TOTAL_NEWS_PER_DAY = 'news_boosting:create:total_news_per_day',
  NEWS_BOOSTING_CREATE_TITLE_COUNT = 'news_boosting:create:keyword:title_count',
  NEWS_BOOSTING_CREATE_BODY_COUNT = 'news_boosting:create:keyword:body_count',
  NEWS_BOOSTING_CREATE_CONTENT_COUNT = 'news_boosting:create:keyword:content_count',
  NEWS_BOOSTING_CREATE_CONTENT_COUNT_SUB_KEYWORD = 'news_boosting:create:sub_keyword:content_count',
  NEWS_BOOSTING_CREATE_SOURCE_COUNT = 'news_boosting:create:source_count',
  NEWS_BOOSTING_CREATE_SOURCE_START_MINUS_DAY = 'news_boosting:create:source_start_minus_day',
  NEWS_BOOSTING_CREATE_SOURCE_MAX = 'news_boosting:create:source_max',
  NEWS_BOOSTING_CREATE_MODEL = 'news_boosting:create:ai_model',
  NEWS_BOOSTING_CREATE_ALLOW_REUSE_SOURCE_ARTICLE = 'news_boosting:create:allow_reuse_source_article',
  NEWS_BOOSTING_CREATE_DAILY_SEARCH_VOLUME_FROM = 'news_boosting:create:daily_search_volume_from',
  NEWS_BOOSTING_CREATE_ALLOW_NEWS_GENERATION = 'news_boosting:create:flag',
  NEWS_BOOSTING_CREATE_KEYWORD_EXCLUDE = 'news_boosting:create:keyword_exclude',
  NEWS_BOOSTING_CREATE_KEYWORD_EXCLUDE_BODY = 'news_boosting:create:keyword_exclude_body',
  NEWS_BOOSTING_CREATE_SOURCE_EXPOSURE_PERIOD_FROM = 'news_boosting:create:source_exposure_period_from',
  NEWS_BOOSTING_CREATE_SOURCE_EXPOSURE_PERIOD_TO = 'news_boosting:create:source_exposure_period_to',

  NEWS_BOOSTING_ADVERTISEMENT_CHECK_PROMPT = 'news_boosting:advertisement:check:prompt',
  NEWS_BOOSTING_FACE_CHECK_PROMPT = 'news_boosting:face:check:prompt',
  NEWS_BOOSTING_GENERATE_PROMPT = 'news_boosting:generate:prompt',


  NEWS_BOOSTING_CREATE_MEDIA_RANK_FROM = 'news_boosting:create:media_rank_from',
  NEWS_BOOSTING_CREATE_MEDIA_RANK_TO = 'news_boosting:create:media_rank_to',
  NEWS_BOOSTING_CREATE_NEWS_SECTION_RANK_FROM = 'news_boosting:create:news_section_rank_from',
  NEWS_BOOSTING_CREATE_NEWS_SECTION_RANK_TO = 'news_boosting:create:news_section_rank_to',

  NEWS_BOOSTING_CREATE_SOURCE_OLD_PUBLISH_DAYS_FROM = 'news_boosting:create:source_old_publish_days_from',
  NEWS_BOOSTING_CREATE_SOURCE_OLD_PUBLISH_DAYS_TO = 'news_boosting:create:source_old_publish_days_to',
  NEWS_BOOSTING_CREATE_SOURCE_CLUSTER_OLD_PUBLISH_DAYS_FROM = 'news_boosting:create:source_cluster_old_publish_days_from',
  NEWS_BOOSTING_CREATE_SOURCE_CLUSTER_OLD_PUBLISH_DAYS_TO = 'news_boosting:create:source_cluster_old_publish_days_to',
  NEWS_BOOSTING_CREATE_SOURCE_MAX_PAGE = 'news_boosting:create:source_max_page',
  NEWS_BOOSTING_CREATE_SOURCE_WORD_COUNT_FROM = 'news_boosting:create:source_word_count_from',



  NEWS_REALTIME_CREATE_PROMPT_FORMAT = 'news_realtime:create:prompt_format',
  NEWS_REALTIME_CREATE_TOTAL_NEWS_PER_DAY = 'news_realtime:create:total_news_per_day',
  NEWS_REALTIME_CREATE_KEYWORD_TITLE_COUNT = 'news_realtime:create:keyword:title_count',
  NEWS_REALTIME_CREATE_KEYWORD_BODY_COUNT = 'news_realtime:create:keyword:body_count',
  NEWS_REALTIME_CREATE_KEYWORD_CONTENT_COUNT = 'news_realtime:create:keyword:content_count',
  NEWS_REALTIME_CREATE_SOURCE_COUNT = 'news_realtime:create:source_count',
  NEWS_REALTIME_CREATE_SOURCE_START_MINUS_DAY = 'news_realtime:create:source_start_minus_day',
  NEWS_REALTIME_CREATE_SOURCE_MAX = 'news_realtime:create:source_max',
  NEWS_REALTIME_CREATE_MODEL = 'news_realtime:create:ai_model',
  NEWS_REALTIME_CREATE_ALLOW_REUSE_SOURCE_ARTICLE = 'news_realtime:create:allow_reuse_source_article',
  NEWS_REALTIME_CREATE_ALLOW_NEWS_GENERATION = 'news_realtime:create:flag',
  NEWS_REALTIME_CREATE_KEYWORD_EXCLUDE = 'news_realtime:create:keyword_exclude',
  NEWS_REALTIME_CREATE_KEYWORD_EXCLUDE_BODY = 'news_realtime:create:keyword_exclude_body',



  SIMULATOR_GENERAL_COMMON_PROMPT = 'simulator:general:common_prompt',
  SIMULATOR_NEWS_COMMON_PROMPT = 'simulator:news:common_prompt',
  SIMULATOR_NAMUWIKI_COMMON_PROMPT = 'simulator:namuwiki:common_prompt',

  SIMULATOR_CAR_COMMON_PROMPT = 'simulator:car:common_prompt',


  SIMULATOR_GENERAL_EXCLUDE_KEYWORDS = 'simulator:general:exclude_keywords',
  SIMULATOR_NEWS_EXCLUDE_KEYWORDS = 'simulator:news:exclude_keywords',
  SIMULATOR_NAMUWIKI_EXCLUDE_KEYWORDS = 'simulator:namuwiki:exclude_keywords',


  KEYWORD_TASK_QUERY_OLD_DATE_FROM = 'keyword_task:query_old_date_from',
  KEYWORD_TASK_QUERY_OLD_DATE_TO = 'keyword_task:query_old_date_to',

  KEYWORD_TASK_GROUP_1_1_TOTAL_CLICK_FROM = 'keyword_task:group_1_1:total_click_from',
  KEYWORD_TASK_GROUP_1_1_DAILY_SEARCH_VOLUME_FROM = 'keyword_task:group_1_1:daily_search_volume_from',
  KEYWORD_TASK_GROUP_1_1_PA_MEDIA_RANK_FROM = 'keyword_task:group_1_1:pa_media_rank_from',

  KEYWORD_TASK_GROUP_1_2_TOTAL_CLICK_FROM = 'keyword_task:group_1_2:total_click_from',
  KEYWORD_TASK_GROUP_1_2_DAILY_SEARCH_VOLUME_FROM = 'keyword_task:group_1_2:daily_search_volume_from',
  KEYWORD_TASK_GROUP_1_2_CATEGORY_NAME = 'keyword_task:group_1_2:category_name',
  KEYWORD_TASK_GROUP_1_2_CATEGORY_ID = 'keyword_task:group_1_2:category_id',

  KEYWORD_TASK_GROUP_2_1_DAILY_SEARCH_VOLUME_FROM = 'keyword_task:group_2_1:daily_search_volume_from',
  KEYWORD_TASK_GROUP_2_1_PA_MEDIA_RANK_FROM = 'keyword_task:group_2_1:pa_media_rank_from',
  KEYWORD_TASK_GROUP_2_1_NEWS_SECTION_RANK_FROM = 'keyword_task:group_2_1:news_section_rank_from',
  KEYWORD_TASK_GROUP_2_1_NEWS_SECTION_RANK_TO = 'keyword_task:group_2_1:news_section_rank_to',

  KEYWORD_TASK_GROUP_2_2_DAILY_SEARCH_VOLUME_FROM = 'keyword_task:group_2_2:daily_search_volume_from',
  KEYWORD_TASK_GROUP_2_2_NEWS_SECTION_RANK_FROM = 'keyword_task:group_2_2:news_section_rank_from',
  KEYWORD_TASK_GROUP_2_2_NEWS_SECTION_RANK_TO = 'keyword_task:group_2_2:news_section_rank_to',
  KEYWORD_TASK_GROUP_2_2_CATEGORY_NAME = 'keyword_task:group_2_2:category_name',
  KEYWORD_TASK_GROUP_2_2_CATEGORY_ID = 'keyword_task:group_2_2:category_id',

  KEYWORD_TASK_GROUP_1_CATEGORY_EXCLUSION_FILTER = 'keyword_task:group_1:category_exclusion_filter',
  KEYWORD_TASK_GROUP_2_CATEGORY_EXCLUSION_FILTER = 'keyword_task:group_2:category_exclusion_filter',

  KEYWORD_REAL_TIME_ADS_HUB_OUTLET_MEDIA_IDS = 'keyword_realtime:ads_hub_outlet_media_ids',

  NEWS_V2_GENERATE_PROMPT = 'news_v2:generate:prompt',
  NEWS_V2_CHECK_PROMPT = 'news_v2:check:prompt',
  NEWS_V2_GENERATE_AI_MODEL = 'news_v2:generate:ai_model',
  NEWS_V2_BLOCKED_SITES = 'news_v2:blocked_sites',

  TRAVEL_NEWS_GENERATE_PROMPT = 'travel_news:generate:prompt',
  TRAVEL_NEWS_GENERATE_AI_MODEL = 'travel_news:generate:ai_model',
  TRAVEL_NEWS_BLOCKED_PLACES = 'travel_news:blocked_places',
  TRAVEL_NEWS_TOP_PERCENTAGE_RANDOM_SELECTION = 'travel_news:top_percentage_random_selection',
  TRAVEL_NEWS_RANDOM_SELECTION_COUNT = 'travel_news:random_selection_count',
  TRAVEL_NEWS_SELECTION_RATIO = 'travel_news:selection_ratio',

  WEATHER_NEWS_GENERATE_HEAD_PROMPT = 'weather_news:generate:head_prompt',
  WEATHER_NEWS_GENERATE_TAIL_PROMPT = 'weather_news:generate:tail_prompt',
  WEATHER_NEWS_GENERATE_AI_MODEL = 'weather_news:generate:ai_model',
  WEATHER_NEWS_BLOCKED_PLACES = 'weather_news:blocked_places',

  WEATHER_WARNING_NEWS_GENERATE_HEAD_PROMPT = 'weather_warning_news:generate:head_prompt',
  WEATHER_WARNING_NEWS_GENERATE_TAIL_PROMPT = 'weather_warning_news:generate:tail_prompt',
  WEATHER_WARNING_NEWS_GENERATE_AI_MODEL = 'weather_warning_news:generate:ai_model',
  WEATHER_WARNING_NEWS_BLOCKED_PLACES = 'weather_warning_news:blocked_places',


  STOCK_NEWS_GENERATE_AI_MODEL = 'stock_news:generate:ai_model',
  STOCK_NEWS_SYSTEM_PROMPT = 'stock_news:system:prompt',
  STOCK_NEWS_STOCK_PROMPT = 'stock_news:stock:prompt',
  STOCK_NEWS_BLOCKED_SITES = 'stock_news:blocked_sites',


  STOCK_TOSS_NEWS_GENERATE_AI_MODEL = 'stock_toss_news:generate:ai_model',
  STOCK_TOSS_NEWS_SYSTEM_PROMPT = 'stock_toss_news:system:prompt',
  STOCK_TOSS_NEWS_STOCK_PROMPT = 'stock_toss_news:stock:prompt',
  STOCK_TOSS_NEWS_BLOCKED_SITES = 'stock_toss_news:blocked_sites',

  GOVERNMENT_IMAGE_BASED_NEWS_GENERATE_HEADER_PROMPT = 'government_image_based_news:generate:header_prompt',
  GOVERNMENT_IMAGE_BASED_NEWS_GENERATE_SYSTEM_PROMPT = 'government_image_based_news:generate:system_prompt',

  GOVERNMENT_LOGO_BASED_NEWS_GENERATE_HEADER_PROMPT = 'government_logo_based_news:generate:header_prompt',
  GOVERNMENT_LOGO_BASED_NEWS_GENERATE_SYSTEM_PROMPT = 'government_logo_based_news:generate:system_prompt',


  APP_TECH_GENERATE_PROMPT = 'app_tech:generate:prompt',
  APP_TECH_GENERATE_AI_MODEL = 'app_tech:generate:ai_model',

  SIMULATOR_NEWS_V2_GENERATE_PROMPT = 'simulator:news_v2:generate:prompt',
  SIMULATOR_NEWS_V2_CHECK_PROMPT = 'simulator:news_v2:check:prompt',

  SIMULATOR_NEWS_TRAVEL_GENERATE_PROMPT = 'simulator:travel_news:generate:prompt',

  SIMULATOR_STOCK_NEWS_STOCK_PROMPT = 'simulator:stock_news:stock:prompt',
  SIMULATOR_STOCK_NEWS_SYSTEM_PROMPT = 'simulator:stock_news:system:prompt',
  SIMULATOR_STOCK_NEWS_GENERATE_AI_MODEL = 'simulator:stock_news:generate:ai_model',

  SIMULATOR_STOCK_TOSS_NEWS_STOCK_PROMPT = 'simulator:stock_toss_news:stock:prompt',
  SIMULATOR_STOCK_TOSS_NEWS_SYSTEM_PROMPT = 'simulator:stock_toss_news:system:prompt',
  SIMULATOR_STOCK_TOSS_NEWS_GENERATE_AI_MODEL = 'simulator:stock_toss_news:generate:ai_model',

  SIMULATOR_WEATHER_NEWS_GENERATE_HEAD_PROMPT = 'simulator:weather_news:generate:head_prompt',
  SIMULATOR_WEATHER_NEWS_GENERATE_TAIL_PROMPT = 'simulator:weather_news:generate:tail_prompt',
  SIMULATOR_WEATHER_WARNING_NEWS_GENERATE_HEAD_PROMPT = 'simulator:weather_warning_news:generate:head_prompt',
  SIMULATOR_WEATHER_WARNING_NEWS_GENERATE_TAIL_PROMPT = 'simulator:weather_warning_news:generate:tail_prompt',
}


export const PROMPT_GENERATE_NEWS_DEFAULT: string = `새로운 기사 제목과 내용을 한국어로 생성하세요. 이는 요약이 아닌 기자가 작성한 것처럼 보이는 기사여야 하며, 최소 1000자 이상이어야 합니다.\n생성된 기사 내용에는 매체 이름이나 기사를 작성한 기자 이름이 포함되지 않습니다.\n기사 내용 외에 다른 설명은 추가하지 마세요.`;

export const PROMPT_GENERAl_NEWS_DEFAULT: string = '';

export const CONFIG_ALLOW_SANITIZE_HTML = {
  allowedTags: ['table', 'tr', 'td', 'th', 'tbody', 'thead', 'tfoot'],
  allowedAttributes: {
    '*': ['href', 'src'],
    'table': ['border', 'width', 'cellpadding', 'cellspacing', 'style'],
    'td': ['colspan', 'rowspan', 'style'],
    'th': ['colspan', 'rowspan', 'style'],
    'tr': ['style'],
    'tbody': ['style'],
    'thead': ['style'],
    'tfoot': ['style']
  },
};

export const TEXT_NAME_CATEGORY_IS_STAR_TREND_KEYWORD = ['디시트렌드', 'StarTrend Keyword']; 